<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1177_1515"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <path
        d="M13.75 5.00002C13.75 4.64546 13.7365 4.31054 13.7144 3.9997C13.6701 3.37865 13.648 3.06812 13.4202 2.67119C13.2502 2.37488 12.863 2.01429 12.5554 1.86572C12.1432 1.66669 11.7506 1.66669 10.9652 1.66669H9.03478C8.24943 1.66669 7.85675 1.66669 7.44464 1.86572C7.137 2.01429 6.74982 2.37488 6.57977 2.67119C6.35197 3.06812 6.32986 3.37865 6.28563 3.9997C6.2635 4.31054 6.25 4.64546 6.25 5.00002M2.5 5.00002H4.16667M17.5 5.00002H4.16667M15.8333 5.00002L15.2813 13.8328C15.1822 15.4174 15.1327 16.2097 14.7926 16.8108C14.4932 17.3399 14.0401 17.7656 13.4933 18.0314C12.8722 18.3334 12.0784 18.3334 10.4906 18.3334H9.50937C7.92163 18.3334 7.12776 18.3334 6.50667 18.0314C5.95989 17.7656 5.50678 17.3399 5.20738 16.8108C4.86727 16.2097 4.81775 15.4174 4.71871 13.8328L4.16667 5.00002"
        stroke="black"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </mask>
    <g mask="url(#mask0_1177_1515)">
      <rect width="20" height="20" fill="#091620" fill-opacity="0.8" />
    </g>
  </svg>
</template>
